import React from 'react';
import './SliderCore.scss';

const DIR_LEFT = 'left';
const DIR_RIGHT = 'right';

export default class SliderCore extends React.Component {
    static defaultProps = {
        slidesToShow: 1,
        autoPlay: true,
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
            direction: DIR_LEFT,
            firstPlaySlideIndex: 0,
            animationLeft: 0,
            animationRight: 1
        };
        this.lastActionTime = new Date();
    }

    componentDidMount() {
        if(this.props.autoPlay){
            this.play();
        }
    }

    componentWillUnmount() {
        this.stop();
    }

    play() {
        this.timer = setTimeout(() => {
            this.setState({
                direction: DIR_LEFT,
                firstPlaySlideIndex: (this.state.firstPlaySlideIndex + 1) % this.props.children.length,
                animationLeft: (this.state.animationLeft + 1) % 2
            });

            this.play();
        }, 6000);
    }

    stop() {
        clearTimeout(this.timer);
    }

    slideLeft() {
        if(!this.prepareAction()){
            return;
        }
        this.setState({
            direction: DIR_LEFT,
            firstPlaySlideIndex: (this.state.firstPlaySlideIndex + 1) % this.props.children.length,
            animationLeft: (this.state.animationLeft + 1) % 2
        });
    }

    slideRight() {
        if(!this.prepareAction()){
            return;
        }

        this.setState({
            direction: DIR_RIGHT,
            firstPlaySlideIndex: this.state.firstPlaySlideIndex == 0 ? this.props.children.length - 1 : this.state.firstPlaySlideIndex - 1,
            animationRight: (this.state.animationRight + 1) % 2
        });
    }

    prepareAction(){
        let now = new Date();
        let ts = now.getTime() - this.lastActionTime.getTime();
        if(ts < 300){
            return false;
        }

        this.lastActionTime = now;
        this.stop();
        if(this.props.autoPlay){
            this.play();
        }

        return true;
    }

    render() {
        let { slidesToShow, children } = this.props;
        let { direction, firstPlaySlideIndex, animationLeft, animationRight } = this.state;
        let dict = this.arrangeSlides();
        let carClassName = 'pubhub-slider-car pubhub-slider-car-move-'
            + (direction == DIR_LEFT ? 'left' : 'right')
            + '-'
            + slidesToShow
            + '-'
            + ((direction == DIR_LEFT ? animationLeft : animationRight) == 0 ? 'a' : 'b');

        return (
            <div className='pubhub-slider-core'>
                <div className={carClassName}>
                    {
                        children.map((child, index) => {
                            return this.renderSlide(direction,
                                child, index, slidesToShow, dict);
                        })
                    }
                </div>
                {
                    this.renderSlideIndicator(firstPlaySlideIndex, children)
                }
            </div>
        );
    }

    renderSlide(direction, child, index, slidesToShow, dict) {
        let position = dict[index];
        let classNames = [
            'pubhub-slider-slide',
            position == undefined ? '' : 'pubhub-slider-slide-show'
        ]
        let x = position == undefined ? 0 : (position * 100 / slidesToShow);
        let width = (100 / slidesToShow);

        let style = {
            marginLeft: index == 0 ? '0%' : (width * -1) + '%',
            left: x + '%',
            width: width + '%',
        };

        return (
            <div key={index}
                className={classNames.join(' ')}
                style={style}>
                {child}
            </div>
        );
    }

    renderSlideIndicator(firstPlaySlideIndex, children) {
        return (
            <div className='pubhub-slider-indicator'>
                {
                    children.map((child, index) => {
                        let className = index == firstPlaySlideIndex ? ' pubhub-slider-indicator-item-actived' : '';
                        return (
                            <span className={'pubhub-slider-indicator-item' + className} key={index}></span>
                        );
                    })
                }
            </div>
        );
    }

    arrangeSlides(){
        let { slidesToShow, children } = this.props;
        let { direction, firstPlaySlideIndex } = this.state;
        let countWithGoneOne = slidesToShow + 1;
        let dict = {};
        for (let position = 0; position < countWithGoneOne; position++) {
            let offset = direction == DIR_LEFT ? -1 : 0;
            let slideIndex = (firstPlaySlideIndex + children.length + offset + position) % children.length;

            dict[slideIndex] = position + offset;
        }

        return dict;
    }
}
